import React from 'react';
import { observer } from 'mobx-react';
import { useAuthStore, useCareerStore } from '../../contexts/mobx';
import { useNavigation } from '../../utils/use-navigation';
import { Career } from '../../stores/career';
import Table, { ColumnProps } from 'antd/lib/table';
import { CreateButton } from '../../components/action-buttons';
import { ImageHolder } from '../../components/image-holder';
import { PageTopBar } from '../../components/page-top-bar';
import { Tag } from '../../components/tag';
import { Spin } from 'antd';

export const CareersPage = observer(() => {
    const store = useCareerStore();
    const navigation = useNavigation();
    const authStore = useAuthStore();

    const { hasManagementAccess } = authStore;

    if (!hasManagementAccess) {
        navigation.goToHome();
    }

    const renderImage = (_: unknown, record: Career) => {
        return <ImageHolder src={record.image.en ?? undefined} size={70} />;
    };

    const renderIsActive = (_: unknown, record: Career) => {
        return record.active ? (
            <Tag variant="success">Active</Tag>
        ) : (
            <Tag variant="error">Inactive</Tag>
        );
    };

    const columns = React.useMemo<ColumnProps<Career>[]>(
        () => [
            {
                title: 'Id',
                dataIndex: 'id',
                key: 'id',
                width: '5rem',
                ellipsis: true,
                render: (_: unknown, record: Career) => (
                    <span>{record.id}</span>
                ),
            },
            {
                title: 'Active',
                dataIndex: 'active',
                key: 'active',
                ellipsis: true,
                width: '7rem',
                render: renderIsActive,
            },
            {
                title: 'Image',
                key: 'image',
                ellipsis: true,
                render: renderImage,
            },
        ],
        []
    );

    React.useEffect(() => {
        store.fetchList();
    }, [store]);

    const goToEditPage = (o: Career) => () => {
        navigation.goToCareerEdit(o.id);
    };

    return (
        <>
            <PageTopBar title={'Careers'}>
                <CreateButton onClick={() => navigation.goToCareerCreate()} />
            </PageTopBar>

            {store.isFetchingList ? (
                <Spin />
            ) : (
                <Table<Career>
                    className="clickable_table_body_rows"
                    rowKey="id"
                    dataSource={store.careerList}
                    columns={columns}
                    loading={store.isFetchingList}
                    pagination={false}
                    bordered
                    onRow={(r) => ({
                        onClick: goToEditPage(r),
                    })}
                />
            )}
        </>
    );
});
